module.exports = __webpack_public_path__ + "static/media/bradesco.b60e5d1c.svg";